<template>
  <j-select-biz-component :width="1000" v-bind="configs" :rowKey="transferUserId" :paginationFlag="paginationFlag" :listUrl="listUrl" v-on="$listeners" :selectButtonText="selectButtonText"/>
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectOperatorSign',
    components: { JSelectBizComponent },
    props: ['value','vendorId','listUrl'],
    data() {
      return {
        selectButtonText:"",
        transferUserId:"transferUserId",
        paginationFlag:false,
        settings: {
          name: '签核人',
          displayKey: 'name',
          returnKeys: ['name','transferUserId'],
          // listUrl: '/construct/sign_operators/'+this.vendorId,
          queryParamCode: 'name',
          queryParamText: '作业人员姓名',
          columns: [
            { title: '入厂证编号', dataIndex: 'workCardNo', align: 'center', width: '30%', widthRight: '70%' },
            { title: '作业人员姓名', dataIndex: 'name', align: 'center', width: '30%', widthRight: '70%' },
            { title: '厂商名称', dataIndex: 'vendorFullName', align: 'center', width: '30%', widthRight: '70%' },
            { title: '手机号', dataIndex: 'phone', align: 'center', width: '35%' },
          ]
        }
      }
    },
    computed: {
      configs() {
        let assign = Object.assign({ value: this.value }, this.settings, this.$attrs);
        if(this.vendorId != null && this.vendorId != 'null' && this.vendorId != undefined){
        }
        return assign;
      }
    }
  }
</script>

<style lang="less" scoped></style>